// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"or-z","imageAndVideoCount":"pr-z","imageAndVideoContainer":"qr-z","viewAllReviews":"rr-z"};